import { connect } from 'react-redux';
import CopyToClipboard from './CopyToClipboardCell';

const mapStateToProps = (state, otherProps) => {
  return {};
};
const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(CopyToClipboard);
